import { HTMLAttributes } from 'react';
import { CardFooter } from '@/shared/ui/core';


export function AuthCardFooter ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <CardFooter
            className={ className }
            data-template="auth-card-footer"
            { ...props }
        />
    );
}
